module.exports = "<!--\n<h1>\n  {{title}}\n</h1>\n-->\n\n<div id=\"mainContainer\" class=\"center\">\n <!-- <app-header></app-header> -->\n  <video-app></video-app>\n  <div id=\"disclaimer\">\n    CASHFLETCHER.COM\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/aubreyfletcher/Desktop/projects/node/node_projects/ng5/cashfletcher_videoPlayer/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main